import React from "react";
import { Button as ChakraButton } from "@chakra-ui/react";

export const Button = ({ children, ...rest }) => {
  return (
    <ChakraButton
      minWidth="130px"
      style={{
        backgroundColor: "#00b0ff",
        borderRadius: "12px",
        boxShadow: "0 4px 8px 0 rgba(0,176,255,.16)",
        color: "#fff",
        fontSize: "18px",
        fontWeight: "600",
        padding: "10px 40px",
        cursor: "pointer",
      }}
      _disabled={{
        backgroundColor: "rgba(128, 128, 128, 0.4)",
        boxShadow: "none",
        cursor: "not-allowed",
      }}
      {...rest}
    >
      {children}
    </ChakraButton>
  );
};
